// ScreenNameContext.js
import React from 'react';

const ScreenNameContext = React.createContext();

export default ScreenNameContext;
